import { Component, DestroyRef, OnInit, Inject, AfterViewInit, inject } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { MatDialogRef , MAT_DIALOG_DATA , MatDialogConfig  } from '@angular/material/dialog';
import { MatTableDataSource  } from '@angular/material/table';

import { BroadcastService } from 'src/app/shared/services/broadcast.service';
import { ReportDTO } from 'src/app/core/classes/orderResult';
import { OrderReportColumn } from 'src/app/core/enumerations/order-report-column';
import { BUCode } from 'src/app/core/enumerations/bu-code';
import { ResultsService } from '../Service/results.service';
import { NotificationService } from 'src/app/shared/services/notification-service';
import { DialogService } from 'src/app/shared/services/dialog.service';
import { TableColumns } from 'src/app/shared/table-columns';
import { GenerateReport } from 'src/app/shared/error-messages';
import { Constants } from 'src/app/shared/constants';
import { ShareReportDialogComponent } from '../share-report-dialog/share-report-dialog.component';
import { LocalStorageService } from 'src/app/shared/services/local-storage.service';
import { ClindxMat2ServiceService } from 'src/app/shared/services/clindx-mat2-service.service';
import { AuthenticationService } from 'src/app/core/services/authentication/authentication.service';

@Component({
    selector: 'app-order-report-dialog',
    templateUrl: './order-report-dialog.component.html',
    styleUrls: ['./order-report-dialog.component.scss'],
    standalone: false
})
export class OrderReportDialogComponent implements OnInit, AfterViewInit {
  private positionRelativeToElement: any;
  public displayedColumns = TableColumns.OrderReportDialogTableColumnNames;
  public dataSource = new MatTableDataSource<ReportDTO>();
  accessionId: string;
  downloadLatestVersion = true;
  businessUnits: any;
  hideShareBtn = false;
  private readonly destroyRef = inject(DestroyRef);
  constructor(@Inject(MAT_DIALOG_DATA) public options: {
    positionRelativeToElement: any, data: any, dialogService: DialogService,
  },
    public dialogRef: MatDialogRef<OrderReportDialogComponent>,
    public broadcastService: BroadcastService,
    private notification: NotificationService,
    private resultService: ResultsService,
    private localStorageService: LocalStorageService,
    private auth: AuthenticationService,
    private clindxMat2TableService: ClindxMat2ServiceService) {
    this.positionRelativeToElement = options.positionRelativeToElement;
    this.hideShareBtn = this.localStorageService.hasDPTORCTXORTGIORVCD();
  }

  ngOnInit() {
    this.dataSource.data = this.options.data.reportDtos;
    this.accessionId = this.options.data.accessionId;
    this.businessUnits = this.auth.GetLoggedInUserDetails().businessUnits;
    if (this.options.data.reportDownloadConfig === 'DownloadLatestVersion') {
      this.downloadLatestVersion = true;
    } else {
      this.downloadLatestVersion = false;
    }
    this.broadcastService.subscribe().pipe(takeUntilDestroyed(this.destroyRef)).subscribe(message => {
      if (message.type === Constants.GENERATED_REPORT_UPDATE) {
        this.dataSource.data = this.options.data.reportDtos;
      }
    });
  }

  ngAfterViewInit() {
    if (window.innerWidth > Constants.EXTRA_SMALL_WIDTH_BREAKPOINT) {
      const matDialogConfig = new MatDialogConfig();
      const rect: DOMRect = this.positionRelativeToElement.getBoundingClientRect();
      const containerRef = document.getElementById(this.dialogRef.id);

      if ((window.innerHeight - containerRef.clientHeight) > rect.bottom) {

        matDialogConfig.position = {
          left: `${(rect.right - rect.width) - containerRef.clientWidth + 20}px`
          , top: `${rect.bottom - 10}px`
        };

      } else {

        matDialogConfig.position = {
          left: `${(rect.right - rect.width) - containerRef.clientWidth + 20}px`,
          top: `${(rect.bottom - 38) - containerRef.clientHeight}px`
        };

      }
      this.dialogRef.updatePosition(matDialogConfig.position);
    }

  }
  getHeaderName(column: string) {
    return OrderReportColumn[column];
  }

  downloadCheck(report: ReportDTO, index: number) {
    if (this.options.data.buCode === BUCode[BUCode.NTD]) {
      return report.isActive;
    }
    if (this.options.data.buCode === BUCode[BUCode.ECD]) {
      return report.isActive;
    }
    if (this.options.data.buCode === BUCode[BUCode.EGL]) {
      return report.isActive && index === 0;
    } else {
      return report.isActive;
    }
  }

  downloadReportCheck(index: number) {
    if (this.downloadLatestVersion && index === 0) {
      return true;
    } else if (this.downloadLatestVersion) {
      return false;
    } else {
      return true;
    }
  }

  public openShareReportDialog(element: ReportDTO) {
    const config = this.options.dialogService.exportConfig;
    config.width = '400px';
    this.options.dialogService.OpenDialog(ShareReportDialogComponent, config, { result: this.options.data, report: element });
  }

  getName(name: string) {
    const val = name.trim().split('.');
    return val[0];
  }

  downloadFile(report: ReportDTO) {
    const request = new ReportDTO();
    request.reportId = report.reportId;
    request.reportName = report.reportName;
    request.isRead = report.isRead;
    request.accessionId = this.accessionId;
    request.buCode = report.buCode;
    if (this.options.data.isOrderTrackerReports) {
      this.resultService.reportDownload(request).subscribe({
        next: (res: any) => { this.openReport(res, false); },
        error: () => this.notification.warn(GenerateReport.FILE_CANT_DOWNLOAD_ERROR_MESSAGE)
      });
    } else {
      this.resultService.downloadReportAndUpdateIsRead(request).subscribe({
        next: (res: any) => { this.openReport(res, request.isRead); },
        error: () => this.notification.warn(GenerateReport.FILE_CANT_DOWNLOAD_ERROR_MESSAGE)
      });
    }
  }

  closeDialog() {
    this.dialogRef.close(false);
  }

  openReport(res: any, isRead: boolean) {
    if (res && res.type !== 'text/plain') {
      const blob = new Blob([res], { type: 'application/pdf' });
      const url = window.URL.createObjectURL(blob);
      this.dialogRef.close(!isRead);
      window.open(url, '_blank');
    } else {
      this.notification.warn(GenerateReport.FILE_NOT_PRESENT_ERROR_MESSAGE);
    }
  }

  // dateParticularDisplayConvert(date: Date) {
  //   if (!this.options.data.reportedOnTimeZone || !this.checkIfDptOrCtxBU()) {
  //     return this.clindxMat2TableService.datePerticularDisplayCheck(date);
  //   } else {
  //     return this.clindxMat2TableService.dateParticularDisplayConvert(date, this.options.data.reportedOnTimeZone);
  //   }
  // }

  checkIfDptOrCtxBU(): boolean {
    if (this.businessUnits[0]?.buCode === Constants.BUCODE_DPT ||
      this.businessUnits[0]?.buCode === Constants.BUCODE_CTX) {
      return true;
    }
    return false;
  }
}
